import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Brands.css";

const API_URL = "https://api.mariamlyluxe.com/public/api/brands";
const BASE = "https://api.mariamlyluxe.com/public";

export default function Brands() {
  const [brands, setBrands] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await fetch(API_URL, { headers: { Accept: "application/json" } });
        const j = await r.json();
        const list = Array.isArray(j?.brands) ? j.brands : [];
        // Filter active brands only, then sort by sort_order, then by id
        const activeBrands = list.filter(brand => brand.is_active === true);
        const sortedBrands = activeBrands.sort((a, b) => {
          const aOrder = parseInt(a.sort_order) || 0;
          const bOrder = parseInt(b.sort_order) || 0;
          if (aOrder !== bOrder) {
            return aOrder - bOrder;
          }
          return a.id - b.id;
        });
        const norm = sortedBrands.map((b) => ({
          ...b,
          image_url: b.image_url
            ? b.image_url
            : b.image
            ? `${BASE}/storage/${String(b.image).replace(/^\/?storage\//, "")}`
            : null,
        }));
        setBrands(norm);
      } catch {
        setBrands([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  // show max 4
  const items = loading ? Array.from({ length: 4 }) : brands.slice(0, 4);
  if (!loading && items.length === 0) return null;

  return (
    <section className="brx" aria-label="Brands">
      <div className="brx-head">
        <div>
          <h2>Brands</h2>
          <p>Kindly take a moment to explore our stunning Brands.</p>
        </div>
        <Link className="brx-view" to="/brands">View All</Link>
      </div>

      <div className="brx-grid">
        {items.map((b, i) => (
          <div key={loading ? i : b.id} className={`brx-card ${loading ? "skel" : ""}`}>
            <div className="brx-media">
              {loading ? null : b.image_url ? (
                <img src={b.image_url} alt={b.name} loading="lazy" decoding="async" />
              ) : (
                <div className="brx-fallback">{getInitials(b.name)}</div>
              )}
            </div>

            {/* name clickable only */}
            <Link className="brx-chip" to={loading ? "#" : `/shop?brand_id=${b.id}`}>
              <span>{loading ? " " : b.name}</span>
              <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M8 5l8 7-8 7"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}

function getInitials(name = "") {
  return name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("");
}
